import { auth } from "../../../../helpers/firebaseConfig";

const DEFAULT_AGENT_API_URL = "https://twin-agent-v2-5r2d6nagzq-uw.a.run.app";

export const AGENT_API_URL = (
  process.env.REACT_APP_TWIN_AGENT_API_URL || DEFAULT_AGENT_API_URL
).replace(/\/$/, "");

export class AgentApiError extends Error {
  constructor(message, status, body = null) {
    super(message);
    this.name = "AgentApiError";
    this.status = status;
    this.body = body;
  }
}

export function formatAgentError(error, connectionMessage = "Couldn’t connect. Check your connection and try again.") {
  const message = String(error?.message || error);
  if (/failed to fetch|networkerror|network request failed/i.test(message)) return connectionMessage;
  return /^agent turn failed[.!]?$/i.test(message) ? "The task couldn’t finish." : message;
}

export function isAgentCancellationEvent(event, requestedJobId) {
  const reason = `${event?.status || ""} ${event?.code || ""} ${event?.reason || ""} ${event?.error || ""} ${event?.message || ""}`;
  if (/cancelled|canceled|cancellation/i.test(reason)) return true;
  const eventJobId = event?.jobId || event?.job_id;
  return Boolean(requestedJobId && (!eventJobId || eventJobId === requestedJobId));
}

export async function agentRequest(path, init = {}) {
  const { withAuth = false, ...fetchInit } = init;
  let authorizationHeaders = {};

  if (withAuth) {
    const user = auth.currentUser;
    if (!user) {
      throw new AgentApiError("Sign in before using the builder agent.", 401);
    }
    authorizationHeaders = { Authorization: `Bearer ${await user.getIdToken()}` };
  }

  const response = await fetch(`${AGENT_API_URL}${path}`, {
    ...fetchInit,
    headers: {
      "Content-Type": "application/json",
      ...(fetchInit.headers || {}),
      ...authorizationHeaders,
    },
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new AgentApiError(
      body?.detail || `Agent request failed: ${response.status}`,
      response.status,
      body,
    );
  }
  return body;
}

const sessionPath = (simulationId, sessionId) =>
  `/model-builders/${encodeURIComponent(simulationId)}/chat-sessions/${encodeURIComponent(sessionId)}`;

export function registerAgentFile(simulationId, sessionId, file) {
  return agentRequest(`${sessionPath(simulationId, sessionId)}/files`, {
    method: "POST",
    body: JSON.stringify({
      name: file.name,
      contentType: file.type || "application/octet-stream",
    }),
  });
}

export function completeAgentFile(simulationId, sessionId, fileId) {
  return agentRequest(`${sessionPath(simulationId, sessionId)}/files/${encodeURIComponent(fileId)}/complete`, {
    method: "POST",
  });
}

export function cancelAgentJob(simulationId, sessionId, jobId) {
  return agentRequest(`${sessionPath(simulationId, sessionId)}/jobs/${encodeURIComponent(jobId)}/cancel`, {
    method: "POST",
  });
}

export function stopAgentTurn(simulationId, sessionId) {
  return agentRequest(`${sessionPath(simulationId, sessionId)}/stop`, {
    method: "POST",
    withAuth: true,
    body: JSON.stringify({}),
  });
}
